import React from 'react';
import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom";
import NavBarLink from './NavBarLink';

const NavBarLink2 = (props) => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  return (
    <>
    <li className="nav-item fs-ss-links right-menu d-block d-lg-none">
          <div class="btn-group dropdown">
          <Link className={splitLocation[1] === `${props.Link_To}` ? `nav-link hover-ss-primary text-ss-primary fw-500 ${props.Border}` : `nav-link hover-ss-primary text-ss-secondary fw-500 ${props.Border}`} to={`/${props.Link_To}`}> {props.Name} </Link>
            <Link class="btn px-4 dropdown-toggle dropdown-toggle-split border-0 text-black" data-bs-toggle="dropdown-menu" aria-expanded="false">
              <span class="visually-hidden">Toggle Dropdown</span>
              </Link>
          </div>
          <ul className="dropdown-menu hover1 fs-ss-links w-content">
            {props.DropdownMenu}
          </ul>
    </li>
    
    <li className="nav-item fs-ss-links right-menu d-none d-lg-block me-lg-3">
          <Link className={splitLocation[1] === `${props.Link_To}` ? `nav-link dropdown-toggle nav-link hover-ss-primary text-ss-primary fw-500 ${props.Border}` : `nav-link dropdown-toggle hover-ss-primary text-ss-secondary fw-500 ${props.Border}`} to={`/${props.Link_To}`}> {props.Name} </Link>
          <ul className="dropdown-menu hover1 fs-ss-links w-content bg-light2 ">
            {props.DropdownMenu}
          </ul>
    </li>
    </>
  )
}

export default NavBarLink2